











import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { namespace } from 'vuex-class'

const layout = namespace('layout')
@Component({
  components: {
    OneButtonToggle: () => import('~/components/molecules/buttons/OneButtonToggle.vue'),
  },
})
export default class OneTaxSwitcherComponent extends Vue {
  @layout.Mutation('SET_PRICE_GROSS') setPriceGross: any
  @layout.State(state => state.priceGross) isPriceGross!: boolean

  @Prop({
    type: Boolean,
    required: false,
    default: false,
  })
  readonly showOnlyForB2B!: boolean

  get shouldShowSwitcher() {
    if (this.$utils.isPurchaseEnabledOrAuthenticated) {
      return this.showOnlyForB2B ? this.$utils.isB2B : true
    }
    return false
  }
}
